<template>
<v-dialog :value="value" @input="!$event && !saving && $emit('close')" :persistent="saving" max-width="700px" scrollable>
      <v-card max-height="500">
        <v-card-title>
          <div><span class="headline">編輯發送時間</span><div v-if="currentItem" class="text-subtitle-2 mt-1">{{ currentItem.tag_name }}</div></div>
        </v-card-title>
        <v-card-text>
          <div v-if="editableMessages.length" style="width: 100%;">
            <div v-for="(msg, index) in editableMessages" :key="msg.id" class="d-flex flex-wrap align-center my-3" style="gap: 8px;">
              <span class="mr-2" style="max-width: 100%; overflow-wrap: anywhere;">{{ msg.title }}</span>

              <!-- EDITING MODE -->
              <template v-if="msg.isEditing">
                <v-menu
                  v-model="datePickerMenus[index]"
                  :disabled="isTimeDisabled(msg)"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="msg.date"
                      :disabled="isTimeDisabled(msg)"
                      label="日期"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      hide-details
                      class="mr-2"
                      style="width: 150px; flex: 0 0 150px;"
                    />
                  </template>
                  <v-date-picker
                    v-model="msg.date"
                    :disabled="isTimeDisabled(msg)"
                    scrollable
                    locale="zh"
                    :min="minDate"
                    @input="datePickerMenus[index] = false"
                  />
                </v-menu>

                <v-select
                  v-model="msg.hour"
                  :disabled="isTimeDisabled(msg)"
                  :items="hours"
                  label="時"
                  dense
                  outlined
                  hide-details
                  class="mr-2"
                  style="width: 96px; flex: 0 0 96px;"
                ></v-select>
                <span class="mr-2">:</span>
                <v-select
                  v-model="msg.minute"
                  :disabled="isTimeDisabled(msg)"
                  :items="minutes"
                  label="分"
                  dense
                  outlined
                  hide-details
                  class="mr-2"
                  style="width: 96px; flex: 0 0 96px;"
                ></v-select>

                <v-select
                  v-model="msg.status"
                  :items="statusOptionsFor(msg)"
                  :disabled="saving"
                  label="發送進度"
                  dense
                  outlined
                  hide-details
                  style="min-width: 150px; max-width: 150px;"
                ></v-select>
              </template>

              <!-- READ-ONLY MODE -->
              <template v-else>
                <span class="mx-2 font-weight-bold">{{ msg.date }} {{ msg.hour }}:{{ msg.minute }}</span>
                <v-chip small dark :color="statusColor(msg.status)">{{ formatStatus(msg.status) }}</v-chip>
              </template>

              <!-- EDIT ACTION -->
              <v-btn v-if="msg.isPotentiallyEditable" :disabled="saving" :aria-label="msg.isEditing ? '取消編輯此訊息' : '編輯此訊息'" small icon @click="$emit('toggle-edit', msg)" class="ml-2">
                <v-icon>{{ msg.isEditing ? 'mdi-close-circle' : 'mdi-pencil' }}</v-icon>
              </v-btn>
            </div>
            <div v-if="editableMessages.some(msg => msg.isEditing && msg.originalStatus === '5')" class="text-caption">
              修改為未來時間後，訊息會重新設為「待發送」。
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex flex-column" style="row-gap: 10px;">
          <div style="width: 300px; max-width: 100%;">
            <v-btn color="tiffany-9" :loading="saving" :disabled="saving" block dark elevation="0" @click="$emit('save')">儲存編輯</v-btn>
          </div>
          <div style="width: 300px; max-width: 100%;">
            <v-btn :disabled="saving" block outlined color="grey-5" @click="$emit('close')">取消</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { careStatusOptions, careStatusColor, careStatusLabel } from '@/utils/careScheduleStatus';
export default {
  name: 'CareScheduleEditDialog',
  props: {
    value: Boolean, saving: Boolean,
    currentItem: { type: Object, default: null },
    editableMessages: { type: Array, default: () => [] },
    minDate: { type: String, default: '' },
  },
  data() {
    return {
      datePickerMenus: [],
      hours: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')),
      minutes: Array.from({ length: 12 }, (_, i) => (i * 5).toString().padStart(2, '0')),
    };
  },
  watch: { value() { this.datePickerMenus = this.editableMessages.map(() => false); } },
  methods: {
    statusColor: careStatusColor,
    formatStatus: careStatusLabel,
    statusOptionsFor(msg) {
      const allowed = msg.originalStatus === '4' ? ['3'] : ['0', '3'];
      return careStatusOptions.filter(option => allowed.includes(option.value) || option.value === msg.originalStatus);
    },
    isTimeDisabled(msg) { return this.saving || msg.originalStatus === '4' || msg.status === '3'; },
  },
};
</script>
